import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { useHistory } from 'react-router-dom';
import { KB_ONBOARDING_PATH } from '../../routing/constants/RouteConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentSuccessModal = () => {
  const history = useHistory();
  return /*#__PURE__*/_jsxs(UIModal, {
    centered: true,
    use: "success",
    width: 540,
    children: [/*#__PURE__*/_jsx(UIDialogHeaderImage, {
      offsetBottom: -30,
      offsetTop: 59,
      children: /*#__PURE__*/_jsx(UIIllustration, {
        alt: "Illustration of a green checkmark",
        name: "success",
        width: 118
      })
    }), /*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx("h2", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3SuccessModal.title"
        })
      })
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.v3SuccessModal.description"
      })
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: () => {
          history.push(`${KB_ONBOARDING_PATH}?cancel=back`);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3SuccessModal.buttonText"
        })
      })
    })]
  });
};
export default EnrollmentSuccessModal;